<template>
  <div>
    <b-card header="Recently Completed">
      <el-table v-loading="loading" :data="getRecentCompletedList">
        <el-table-column prop="code" sortable label="Code" width="120"></el-table-column>
        <el-table-column prop="fullname" sortable label="Name">
          <template slot-scope="scope">
            <router-link :to="'/user/' + scope.row.id">{{ scope.row.fullname}}</router-link>
          </template>
        </el-table-column>
        <el-table-column prop="package" sortable label="Package"></el-table-column>
        <el-table-column prop="instrument" sortable label="Instrument"></el-table-column>
        <el-table-column label="Date">
          <template slot-scope="scope">
            <i class="el-icon-time"></i>
            <span style="margin-left: 10px">{{ formatDate(scope.row.completionDate) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="Operations" width="120">
          <template slot-scope="scope">
            <el-button size="mini" @click="viewProfile(scope.$index, scope.row)">View</el-button>
          </template>
        </el-table-column>
      </el-table>
    </b-card>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';

export default {
  name: 'recentCompleted',
  computed: {
    ...mapGetters('recent', ['getRecentCompletedList'])
  },
  data: function() {
    return {
      loading: false
    };
  },
  created() {
    this.loading = true;
    this.fetchRecentlyCompleted().then(r => {
      this.loading = false;
    });
  },
  methods: {
    ...mapActions('recent', ['fetchRecentlyCompleted']),
    viewProfile(index, i) {
      this.$router.push('/user/' + i.id);
    },
    formatDate(input) {
      return moment(input).format('M/D/YYYY h:mm a zz');
    }
  }
};
</script>
